namespace Gamification.Gamification {
    export interface ChecklistNodiRow {
        IdChecklistNodo?: number;
        IdChecklist?: number;
        IdNodo?: number;
        IdChecklistNome?: string;
        IdChecklistIdAssetEsperienza?: number;
        IdChecklistProgressivo?: number;
        IdNodoNome?: string;
        IdNodoDescrizione?: string;
        IdNodoIdRisorsa?: number;
        IdNodoProgressivo?: number;
        IdNodoAnimationPath?: string;
        IdNodoPunteggio?: string;
        IdNodoCrediti?: number;
        IdNodoExp?: number;
        IdNodoIdBadge?: number;
        IdNodoIdClasse?: number;
        IdNodoIdMissione?: number;
        IdNodoPunteggioMissioneDropDown?: string;
        IdNodoPuteggioMissoneTesto?: number;
        IdNodoIdClasseMissone?: string;
    }

    export namespace ChecklistNodiRow {
        export const idProperty = 'IdChecklistNodo';
        export const localTextPrefix = 'Gamification.ChecklistNodi';
        export const lookupKey = 'Gamification.ChecklistNodi';

        export function getLookup(): Q.Lookup<ChecklistNodiRow> {
            return Q.getLookup<ChecklistNodiRow>('Gamification.ChecklistNodi');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdChecklistNodo = "IdChecklistNodo",
            IdChecklist = "IdChecklist",
            IdNodo = "IdNodo",
            IdChecklistNome = "IdChecklistNome",
            IdChecklistIdAssetEsperienza = "IdChecklistIdAssetEsperienza",
            IdChecklistProgressivo = "IdChecklistProgressivo",
            IdNodoNome = "IdNodoNome",
            IdNodoDescrizione = "IdNodoDescrizione",
            IdNodoIdRisorsa = "IdNodoIdRisorsa",
            IdNodoProgressivo = "IdNodoProgressivo",
            IdNodoAnimationPath = "IdNodoAnimationPath",
            IdNodoPunteggio = "IdNodoPunteggio",
            IdNodoCrediti = "IdNodoCrediti",
            IdNodoExp = "IdNodoExp",
            IdNodoIdBadge = "IdNodoIdBadge",
            IdNodoIdClasse = "IdNodoIdClasse",
            IdNodoIdMissione = "IdNodoIdMissione",
            IdNodoPunteggioMissioneDropDown = "IdNodoPunteggioMissioneDropDown",
            IdNodoPuteggioMissoneTesto = "IdNodoPuteggioMissoneTesto",
            IdNodoIdClasseMissone = "IdNodoIdClasseMissone"
        }
    }
}
